module.exports = __webpack_public_path__ + "static/media/damien.be272bba.jpg";